import { Link } from 'react-router-dom';

const blogArticles = [
  {
    slug: '/blog/mulebuy-spreadsheet-vs-agent',
    title: 'Mulebuy Spreadsheet vs Agent Shopping — Full Comparison',
    description: 'Detailed comparison between mulebuy spreadsheet sourcing and traditional agent shopping. See which method saves you more time and reduces risk.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20between%20digital%20spreadsheet%20on%20laptop%20versus%20phone%20call%20with%20agent%2C%20modern%20vs%20traditional%20sourcing%20methods%2C%20clean%20corporate%20illustration%20style%2C%20soft%20professional%20lighting%2C%20conceptual%20business%20photography&width=600&height=400&seq=blog-compare-vs-agent&orientation=landscape',
    tag: 'Comparison Guide',
  },
  {
    slug: '/blog/how-to-use-mulebuy-spreadsheet',
    title: 'How to Use Mulebuy Spreadsheet Effectively',
    description: 'Step-by-step tutorial on using mulebuy spreadsheet for product sourcing. Master data filtering, agent comparison, and smart buying decisions.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Hands%20typing%20on%20keyboard%20with%20spreadsheet%20visible%20on%20monitor%20showing%20product%20data%20rows%2C%20notebook%20with%20handwritten%20notes%20beside%2C%20warm%20desk%20lamp%20glow%2C%20focused%20work%20atmosphere%2C%20evening%20productivity%20scene&width=600&height=400&seq=blog-how-to-use&orientation=landscape',
    tag: 'Tutorial',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-benefits',
    title: 'Key Benefits of Using Mulebuy Spreadsheet',
    description: 'Discover the top advantages of mulebuy spreadsheet. Save money, reduce sourcing errors, and find better suppliers with verified data at your fingertips.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Happy%20entrepreneur%20sitting%20at%20cafe%20table%20with%20laptop%20showing%20graphs%20and%20charts%2C%20green%20upward%20arrows%20on%20screen%2C%20sunny%20outdoor%20setting%2C%20successful%20business%20lifestyle%2C%20bright%20natural%20photography&width=600&height=400&seq=blog-benefits&orientation=landscape',
    tag: 'Benefits',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-pricing',
    title: 'Mulebuy Spreadsheet Pricing & Cost Guide',
    description: 'Complete breakdown of mulebuy spreadsheet costs, agent fees, and hidden expenses. Make informed decisions with our transparent pricing analysis.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Calculator%20and%20receipts%20next%20to%20laptop%20showing%20pricing%20tables%2C%20glass%20jar%20with%20coins%2C%20organized%20financial%20planning%20desk%2C%20warm%20morning%20lighting%2C%20clean%20budgeting%20photography&width=600&height=400&seq=blog-pricing&orientation=landscape',
    tag: 'Pricing',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-tips',
    title: 'Expert Tips for Mulebuy Spreadsheet Power Users',
    description: 'Advanced tips and tricks for mulebuy spreadsheet enthusiasts. Unlock hidden features, speed up your workflow, and become a sourcing expert.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20using%20laptop%20with%20multiple%20monitors%20showing%20complex%20spreadsheets%20and%20data%2C%20coffee%20mug%20and%20headphones%2C%20modern%20tech%20workspace%2C%20focused%20professional%2C%20evening%20ambient%20lighting&width=600&height=400&seq=blog-tips&orientation=landscape',
    tag: 'Tips & Tricks',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-mistakes',
    title: 'Common Mulebuy Spreadsheet Mistakes to Avoid',
    description: 'Avoid costly errors when using mulebuy spreadsheet. Learn the most frequent mistakes beginners make and how to navigate around them safely.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warning%20sign%20and%20red%20flags%20on%20desk%20next%20to%20laptop%2C%20document%20with%20errors%20highlighted%2C%20cautionary%20business%20scene%2C%20soft%20office%20lighting%2C%20conceptual%20risk%20awareness%20photography&width=600&height=400&seq=blog-mistakes&orientation=landscape',
    tag: 'Mistakes',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-beginners',
    title: 'Mulebuy Spreadsheet for Absolute Beginners',
    description: 'New to mulebuy spreadsheet? Start here. Our beginner-friendly guide covers everything from spreadsheet basics to making your first informed purchase.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20laptop%20with%20simple%20spreadsheet%20showing%20basic%20product%20list%2C%20cup%20of%20tea%20and%20open%20guidebook%2C%20cozy%20home%20setting%2C%20warm%20afternoon%20light%2C%20friendly%20beginner%20learning%20atmosphere&width=600&height=400&seq=blog-beginners&orientation=landscape',
    tag: 'Beginner Guide',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-update-frequency',
    title: 'How Often Should You Update Mulebuy Spreadsheet',
    description: 'Find the optimal update frequency for your mulebuy spreadsheet. Stay ahead with fresh data without wasting time on unnecessary refreshes.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Calendar%20and%20clock%20next%20to%20laptop%20showing%20refresh%20icon%2C%20organized%20planner%20with%20marked%20dates%2C%20clean%20modern%20desk%20setup%2C%20time%20management%20concept%2C%20bright%20natural%20daylight&width=600&height=400&seq=blog-update-freq&orientation=landscape',
    tag: 'Maintenance',
  },
  {
    slug: '/blog/mulebuy-spreadsheet-success-stories',
    title: 'Real Success Stories Using Mulebuy Spreadsheet',
    description: 'Inspiring stories from real users who transformed their sourcing with mulebuy spreadsheet. See how others saved thousands and built profitable businesses.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Small%20business%20owner%20smiling%20while%20reviewing%20packages%20in%20warehouse%2C%20cardboard%20boxes%20stacked%2C%20tablet%20showing%20inventory%20data%2C%20successful%20ecommerce%20scene%2C%20bright%20optimistic%20lighting&width=600&height=400&seq=blog-success&orientation=landscape',
    tag: 'Success Stories',
  },
];

export default function BlogSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm text-foreground-500 font-label tracking-wide uppercase mb-3">
            SEO Knowledge Base
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
            Mulebuy Spreadsheet
            <br />
            <span className="italic font-light">Articles &amp; Guides</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mt-4 leading-relaxed">
            Deep-dive into mulebuy spreadsheet knowledge. Expert-written articles covering comparisons, tutorials, tips, and real success stories.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group bg-white rounded-2xl overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap mb-3">
                  {article.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-foreground-800 font-medium mt-3 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}